import React from 'react';
import { cx } from './classes';

// "Drums · Kick", or just the category when there's no type ("Full mix")
export const instrumentLabel = (category, type) => (type ? `${category} · ${type}` : category || '');

/**
 * The read-only instrument tag, one ground step above what it sits on: pass on="surface" when it sits
 * on a surface card (it is then raised), otherwise it sits on base (and is surface).
 */
export const InstrumentTag = ({ category, type, on = 'base', className }) => (
  <span
    className={cx(
      'inline-flex items-center px-space-3 py-space-1 rounded-radius-pill font-text text-label text-ink-soft',
      on === 'surface' ? 'bg-raised' : 'bg-surface',
      className
    )}
  >
    {instrumentLabel(category, type)}
  </span>
);
